import { useEffect } from "react";
import { useAdsConsent } from "@/lib/consent";
import { useProduct } from "@/lib/product";
import { track, PRODUCT_ID, PRODUCT_NAME } from "@/lib/metaPixel";

let fired = false;

export const ViewContentTracker = () => {
  const ads = useAdsConsent();
  const { product } = useProduct();
  const price = product?.current_price;

  useEffect(() => {
    if (fired || !ads || price == null) return;
    const t = setTimeout(() => {
      if (!fired && track("ViewContent", { value: price, currency: "EUR", content_ids: [PRODUCT_ID], content_type: "product", content_name: PRODUCT_NAME })) fired = true;
    }, 0);
    return () => clearTimeout(t);
  }, [ads, price]);

  return null;
};
